import { createTheme } from "@mui/material";
import { common } from "@mui/material/colors";
import config from "../config/config";
import { DEFAULT_CLIENT } from "./constants";

const { REACT_APP_CLIENT_NAME: clientEnv } = config;

const COATI_COLOR = "#E32728";
const BNA_COLOR = "#F16C29";
const MACRO_COLOR = "#0038e2";


const baseTheme = createTheme({
  palette: {
    primary: {
      main: COATI_COLOR,
      contrastText: common.white,
    },
    success: {
      main: "#0C88FC",
      contrastText: common.white,
    },
    error: {
      main: "#D90001",
      contrastText: common.white,
    },
    warning: {
      main: "#E3D027",
      contrastText: common.black,
    },
    info: {
      main: "#F96E20",
      contrastText: common.white,
    },
    secondary: {
      main: "#EBEBEB",
      contrastText: "#181818",
    },
    contrastThreshold: 3,
  },
  typography: {
    h1: {
      color: "#181818",
    },
    h2: {
      color: "#181818",
      fontSize: "1.5rem",
    },
    h3: {
      color: "#181818",
    },
    h4: {
      color: "#181818",
    },
    h5: {
      color: "#181818",
    },
    h6: {
      color: "#181818",
    },
    body1: {
      color: "#181818",
    },
    fontFamily: [
      "Lato",
      "Roboto",
      "Helvetica Neue",
      "Arial",
      "sans-serif",
    ].join(","),
  },
  components: {
    MuiListItemButton: {
      styleOverrides: {
        root: {
          "&.active": {
            "*": {
              color: COATI_COLOR,
            },
          }
        }
      }
    },
    MuiSvgIcon: {
      styleOverrides: {
        root: {
          color: COATI_COLOR
        }
      }
    },
    MuiOutlinedInput: {
      styleOverrides: {
        input: {
          "&::placeholder": {
            fontSize: 14,
            color: "#181818",
          },
        },
      },
    },
    MuiMenuItem: {
      styleOverrides: {
        root: {
          fontSize: 14,
        },
      },
    },
  },
});

const themes = {
  coati: createTheme({
    ...baseTheme,
  }),
  bna: createTheme({
    ...baseTheme,
    palette: {
      ...baseTheme.palette,
      primary: {
        main: BNA_COLOR,
      },
    },
    components: {
      ...baseTheme.components,
      MuiListItemButton: {
        styleOverrides: {
          root: {
            "&.active": {
              "*": {
                color: BNA_COLOR,
              },
            }
          }
        }
      },
      MuiSvgIcon: {
        styleOverrides: {
          root: {
            color: BNA_COLOR
          }
        }
      },
    }
  }),
  macro: createTheme({
    ...baseTheme,
    palette: {
      ...baseTheme.palette,
      primary: {
        main: MACRO_COLOR,
      },
    },
    components: {
      ...baseTheme.components,
      MuiListItemButton: {
        styleOverrides: {
          root: {
            "&.active": {
              "*": {
                color: MACRO_COLOR,
              },
            }
          }
        }
      },
      MuiSvgIcon: {
        styleOverrides: {
          root: {
            color: MACRO_COLOR
          }
        }
      },
    }
  }),
};


export const getClientTheme = () => {

  if (!clientEnv || !(clientEnv in themes)) {
    console.warn(`${DEFAULT_CLIENT}`);
    return themes[DEFAULT_CLIENT];
  }

  return themes[clientEnv];
};
